export default "__VITE_ASSET__73fdf988__"